import { AUTH_TRANSACTION_ACTION_TYPE } from "./auth-transaction.action";

export const AUTH_TRANSACTION_CODES = {
	validationError: "E_VALIDATION",
	authenticationError: "E_AUTHENTICATION",
	verificationStatus: {
		start: "M_VERIFICATION_START",
		completed: "M_VERIFICATION_SUCCESS",
		failed: {
			generic: "E_VERIFICATION_FAILED",
			cancelled: "E_VERIFICATION_FAILED_CANCELLED",
			userCancel: "E_VERIFICATION_FAILED_USER_CANCEL",
			expiredTransaction: "E_VERIFICATION_FAILED_EXPIRED_TRANSACTION",
			certificateError: "E_VERIFICATION_FAILED_CERTIFICATE_ERROR",
			startFailed: "E_VERIFICATION_FAILED_START_FAILED",
			alreadyInProgress: "E_VERIFICATION_FAILED_ALREADY_IN_PROGRESS",
			unknown: "E_VERIFICATION_FAILED_UNKNOWN",
			providerError: "E_VERIFICATION_FAILED_PROVIDER_ERROR",
			timeout: "E_VERIFICATION_TIMEOUT",
			alreadyUsed: "E_AUTHENTICATION_ALREADYUSED_PERSONALNUMBER",
		},
	},
	cancelLastVerification: {
		success: "M_CANCEL_LAST_VERIFICATION_SUCCESS",
	},
	initializeAuthTransaction: {
		success: "M_INITIALIZE_AUTH_TRANSACTION_SUCCESS",
	},
};

export const AUTH_TRANSACTION_MESSAGE_CONTEXT = {
	getVerificationStatus: AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatus,
	initializeVerification: AUTH_TRANSACTION_ACTION_TYPE.initializeVerification,
	initializeAuthTransaction: AUTH_TRANSACTION_ACTION_TYPE.initializeAuthTransaction,
	cancelLastVerification: AUTH_TRANSACTION_ACTION_TYPE.cancelLastVerification,
};

export const FAIL_HINT_CODES = [
	AUTH_TRANSACTION_CODES.verificationStatus.failed.alreadyInProgress,
	AUTH_TRANSACTION_CODES.verificationStatus.failed.certificateError,
	AUTH_TRANSACTION_CODES.verificationStatus.failed.expiredTransaction,
	AUTH_TRANSACTION_CODES.verificationStatus.failed.providerError,
	AUTH_TRANSACTION_CODES.verificationStatus.failed.startFailed,
	AUTH_TRANSACTION_CODES.verificationStatus.failed.unknown,
	AUTH_TRANSACTION_CODES.verificationStatus.failed.timeout,
	AUTH_TRANSACTION_CODES.verificationStatus.failed.alreadyUsed,
];

export const NOOP_HINT_CODES = [
	AUTH_TRANSACTION_MESSAGE_CONTEXT.initializeVerification,
	AUTH_TRANSACTION_CODES.verificationStatus.start,
	AUTH_TRANSACTION_CODES.verificationStatus.completed,
];

export const CANCEL_HINT_CODES = [
	AUTH_TRANSACTION_CODES.verificationStatus.failed.userCancel,
	AUTH_TRANSACTION_CODES.verificationStatus.failed.cancelled,
];

export const PERSONAL_NUMBER_CODES = {
	noDataError: "E_PERSONALVERIFICATION_NODATA",
	validationError: "E_VALIDATION",
	validationErrorInvalidCheckSum: "E_VALIDATION_PERSONALNUMBERINVALIDCHECKSUM",
	validationErrorPersonalNumber: "E_VALIDATION_PERSONALNUMBER",
	validationErrorInvalidDate: "E_VALIDATION_PERSONALNUMBERINVALIDDATE",
	validationErrorPersonalNumberUnderage: "E_VALIDATION_PERSONALNUMBERUNDERAGE",
	validationErrorPersonalNumberLength: "E_VALIDATION_PERSONALNUMBERINVALIDLENGTH",
	addressNotInSwedenError: "E_PERSONALNUMBER_ADDRESSNOTINSWEDEN",
	invalidPersonalNumberError: "E_PERSONALNUMBER_INVALIDPERSONALNUMBER",
	notFoundError: "E_PERSONALNUMBER_SPARLOOKUP_PERSONALNUMBERNOTFOUND",
	serviceGenericError: "E_PERSONALNUMBER_SPARLOOKUP",
	serviceInvalidRequest: "E_PERSONALNUMBER_SPARLOOKUP_INVALIDREQUEST",
	serviceRateLimitExceededError: "E_PERSONALNUMBER_SPARLOOKUP_MAXATTEMPTSREACHED",
	serviceUnavailableError: "E_PERSONALNUMBER_SPARLOOKUP_UNAVAILABLE",
};

export const REDIRECT_HASH = "redirect";
